/**
 * O id do bloco de uma pergunta na página.
 *
 * Mora fora do componente porque quem o usa está dos dois lados: a pergunta o declara e o painel
 * de impedimentos aponta para ele. Sem um lugar comum, o prefixo viraria uma string repetida em
 * dois arquivos — e o dia em que um mudasse, o link do impedimento levaria a lugar nenhum.
 */
export function ancoraDaPergunta(perguntaId: string): string {
  return `pergunta-${perguntaId}`;
}
